import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { unblockUser } from "../../../actions/blockuser";

const UnblockUserSettings = ({
  UnblockUser: { channelid, avatar, firstname, lastname, jobtitle, location },
  unblockUser,
  setUnblockUser,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() => setUnblockUser({ request: false, confirm: false })}
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font bold">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location && location.city}, {location && location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Are you sure you would like to unblock{" "}
            <span className="red bold">
              {firstname} {lastname}
            </span>
            ? This user will be able to view your profile and participate in
            your live stream chat.
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-red"
              onClick={() => {
                unblockUser(channelid);
                setUnblockUser({ request: false, confirm: true });
              }}
            >
              <i className="fa-solid fa-ban fa-sm mr-5"></i>
              Unblock
            </button>
            <button
              className="user-request-button background-red"
              onClick={() => setUnblockUser({ request: false, confirm: false })}
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

UnblockUserSettings.propTypes = {
  unblockUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  unblockUser,
})(UnblockUserSettings);
